import { useNavigate, useParams } from 'react-router-dom';
import { ObjectCardBody } from '../../components/shared/ObjectCardBody';

export function ObjectCardPage() {
  const { layerId, featureId } = useParams<{ layerId: string; featureId: string }>();
  const navigate = useNavigate();

  if (!layerId || !featureId) return null;

  return (
    <ObjectCardBody
      layerId={layerId}
      featureId={featureId}
      onNavigateFeature={(id) => navigate(`/app/data/layers/${layerId}/objects/${id}`)}
      onAfterDelete={() => navigate(`/app/data/layers/${layerId}/table`)}
      closeLabel="← Назад к слою"
      onRequestClose={() => navigate(`/app/data/layers/${layerId}/table`)}
    />
  );
}
